import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { settingsPanelStyles as styles } from './styles';
import { SketchPicker } from 'react-color';
import { ChromePicker } from 'react-color';
import reactCSS from 'reactcss';
import ReactTooltip from 'react-tooltip';

const color_picker = require('../icons/color_picker.svg');

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

class ColorPicker extends Component<IProps, any> {
    state = {
        displayColorPicker: false,
    };

    handleClickColor = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleCloseColor = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChangeColor = (color) => {
        this.props.descriptor.style.color = color.hex;
    };

    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        const styles = reactCSS({
            default: {
                color: {
                    width: '180px',
                    height: '14px',
                    borderRadius: '2px',
                    backgroundColor: 'black',
                },
                popover: {
                    position: 'absolute',
                    right: '0',
                    bottom: '50px',
                    zIndex: 1,
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
                root: {
                    display: 'flex',
                    flexDirection: 'column',
                },
                input: {
                    width: 80,
                    marginLeft: 20,
                    height: 25,
                    textAlign: 'center',
                    borderRadius: 2,
                    border: '1px solid #CDCED1',
                    boxShadow: '0 2px 4px 0 rgba(0,0,0,.12)',
                    color: '#000000',
                },
            },
        });
        return (
            <div className={classes.root} style={{ position: 'relative', zIndex: 0 }}>
                <div
                    style={{
                        display: 'flex',
                        // flexDirection: 'column',
                    }}>
                    <span className={classes.header} style={{ width: '130px' }}>
                        Color{' '}
                    </span>

                    <button
                        style={{
                            backgroundColor: this.props.descriptor.style.color as string,
                            border: '2px solid transparent',
                            width: '30px',
                            borderRadius: '4px',
                        }}
                    />
                    <input className={classes.input} style={{ width: '75px', marginLeft: '5px' }} type="text" name="selected_color" value={this.props.descriptor.style.color as string} />
                    <img src={color_picker} onClick={this.handleClickColor} style={{ marginLeft: '15px' }} data-for="color" title="Pick Color" />
                    {this.state.displayColorPicker ? (
                        <div style={styles.popover}>
                            <div style={styles.cover} onClick={this.handleCloseColor} />
                            <ChromePicker color={this.props.descriptor.style.color} onChange={this.handleChangeColor} />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(ColorPicker));
